// extracted by mini-css-extract-plugin
export default {"leave-encash-header":"LeaveEncashmentReport_leave-encash-header__cIsl0","divider":"LeaveEncashmentReport_divider__09CBG"};